import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "payout-methods" }
const _hoisted_2 = { class: "row justify-between items-center" }
const _hoisted_3 = {
  key: 2,
  class: "panel-body"
}
const _hoisted_4 = {
  key: 3,
  class: "payout-accounts"
}
const _hoisted_5 = {
  key: 0,
  class: "text-body-light no-payment-method"
}
const _hoisted_6 = {
  key: 1,
  class: "text-body-light no-payment-method"
}
const _hoisted_7 = {
  key: 2,
  class: "text-body-light no-payment-method"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "tag"
}
const _hoisted_10 = {
  key: 1,
  class: "tag"
}
const _hoisted_11 = {
  key: 2,
  class: "tag blocked"
}
const _hoisted_12 = { class: "method-name" }
const _hoisted_13 = {
  key: 0,
  class: "method-status"
}
const _hoisted_14 = { class: "text-success" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "dialog-body"
}
const _hoisted_18 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_PayoutMethodOptionsDialog = _resolveComponent("PayoutMethodOptionsDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Payout Methods ", -1)
      ]))])), [
        [_directive_translate]
      ]),
      (_ctx.isLoadingLinks)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
        : (!_ctx.isLoading && !_ctx.isImpersonateMode && !_ctx.isAllMethodsRegistered)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAddNewDialog && _ctx.showAddNewDialog(...args)))
            }, [
              _createVNode(_component_Icon, { name: "plus-circle" }),
              _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Add new", -1)
              ]))])), [
                [_directive_translate]
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Notification, {
          key: 0,
          "icon-name": "danger",
          title: _ctx.$gettext('Failed retrieving your payout methods'),
          message: _ctx.error
        }, null, 8, ["title", "message"]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
        : (_ctx.isImpersonateMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createElementBlock("em", null, [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Please use the admin panel to manage payout methods for this user.", -1)
              ]))])), [
                [_directive_translate]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.hasRejectedPayoneerAccount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Your Payoneer account application has been ", -1),
                      _createElementVNode("strong", null, "declined", -1),
                      _createTextVNode(". ", -1)
                    ]))])), [
                      [_directive_translate]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Please ", -1),
                      _createElementVNode("a", {
                        href: "https://support.dittomusic.com/",
                        target: "_blank"
                      }, "contact our support team", -1),
                      _createTextVNode(". ", -1)
                    ]))])), [
                      [_directive_translate]
                    ])
                  ]))
                : (_ctx.hasPendingPayoneerAccount)
                  ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" We’re still processing your Payoneer account. Please check back later. ", -1)
                    ]))])), [
                      [_directive_translate]
                    ])
                  : _createCommentVNode("", true),
              (!_ctx.payoutAccounts.length)
                ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Set up a payout method to withdraw your royalties. ", -1)
                  ]))])), [
                    [_directive_translate]
                  ])
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.listedPayoutMethods, (account) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${account.type}-${account.id}`,
                      class: _normalizeClass(["payout-method-option read-only items-center", account.status])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`method-image ${account.type}`)
                      }, [
                        _createElementVNode("img", {
                          src: String(_ctx.getPayoutMethodImg(account.type).imgSrc),
                          alt: _ctx.getPayoutMethodImg(account.type).imgAltText
                        }, null, 8, _hoisted_8),
                        (account.status === _ctx.payoutAccountStatuses.active)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                              _createTextVNode(" Active ", -1)
                            ]))])), [
                              [_directive_translate]
                            ])
                          : (account.status === _ctx.payoutAccountStatuses.pending)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[10] || (_cache[10] = [
                                _createTextVNode(" Pending ", -1)
                              ]))])), [
                                [_directive_translate]
                              ])
                            : (account.status === _ctx.payoutAccountStatuses.blocked)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode(" Blocked ", -1)
                                ]))])), [
                                  [_directive_translate]
                                ])
                              : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h4", null, _toDisplayString(account.name), 1),
                        (account.isVerified)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                              _createVNode(_component_Icon, {
                                name: "verified",
                                fill: "success"
                              }),
                              _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_14, [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("Confirmed", -1)
                              ]))])), [
                                [_directive_translate]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isAccountEditable(account))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("button", {
                              class: "edit-method tertiary button-small button-round",
                              disabled: _ctx.isLoadingLinks,
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openTipaltiDialog && _ctx.openTipaltiDialog(...args)))
                            }, [
                              _createVNode(_component_Icon, { name: "edit" })
                            ], 8, _hoisted_16)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
            ])),
    _createVNode(_component_PayoutMethodOptionsDialog, {
      ref: "AddNewDialog",
      onPayoneerSelected: _ctx.redirectToPayoneer,
      onTipaltiSelected: _ctx.openTipaltiDialog
    }, null, 8, ["onPayoneerSelected", "onTipaltiSelected"]),
    _createVNode(_component_Dialog, {
      ref: "TipaltiDialog",
      class: "tipalti-dialog",
      dismissible: "",
      size: "large",
      title: _ctx.hasTipaltiAccount ? _ctx.$gettext('Edit a Payout Method') : _ctx.$gettext('Setup a Payout Method'),
      onDialogClosed: _ctx.getPayoutAccounts
    }, {
      default: _withCtx(() => [
        (_ctx.widgetLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("iframe", {
                src: _ctx.widgetLink,
                title: _ctx.$gettext('Manage Payout Methods')
              }, null, 8, _hoisted_18)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "onDialogClosed"])
  ]))
}